import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { useFormik } from "formik";
import { AreaI } from "interfaces/Area";
import { NivelI } from "interfaces/Nivel";
import { TituloI } from "interfaces/Titulo";
import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createAreaSchema } from "schemas/area/CreateAreaSchema";
import { createTitulosSchema } from "schemas/titulos/createTitulosSchema";
import { postArea, putArea } from "services/area";
import { getNiveles } from "services/niveles";
import { postTitulo } from "services/titulos";
import { RootState } from "store/store";
import { AsyncSelect } from "components/AsyncInput/AsyncSelect";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: AreaI;
  onSuccess?: (titulo: TituloI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
  descripcion: string;
  nivel_id: number | string;
}

interface defaultOptionsSelected {
  default_selected_nivel: NivelI | null;
}

export const AreaABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType === "edit";
  const initialValues: initialValues = {
    nombre: "",
    descripcion: "",
    nivel_id: "",
  };

  const [defaultOptionsSelected, setDefaultOptionsSelected] =
    useState<defaultOptionsSelected>({
      default_selected_nivel: null,
    });

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
        descripcion: elemento?.descripcion ?? "",
        nivel_id: elemento?.nivel.id ?? "",
      };
      setDefaultOptionsSelected({
        default_selected_nivel: {
          id: elemento.nivel.id,
          nombre: elemento.nivel.nombre,
        },
      });
    } else {
      currentValues = initialValues;
      setDefaultOptionsSelected({
        default_selected_nivel: null,
      });
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      const newArea = await postArea({ params });
      showSuccessToast("¡El área fue creada con éxito!");
      if (onSuccess) onSuccess(newArea);
      onClose();
    } catch (err: any) {
      showErrorToast("El área no pudo ser creada.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      const newArea = await putArea({ params });
      showSuccessToast("¡El área fue editada con éxito!");
      if (onSuccess) onSuccess(newArea);
      onClose();
    } catch (err: any) {
      showErrorToast("El área no pudo ser editada.");
      console.log(err.message);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createAreaSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa } = useSelector(
    (st: RootState) => st.appData,
  );

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>{isEditMode ? "Editar Área" : "Nuevo Área"}</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={6}>
                  <Input
                    id={"nombre"}
                    title="Nombre del área"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={6}>
                  <Input
                    id={"descripcion"}
                    title="Descripción"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="mt-1 mb-4">
                  <AsyncSelect
                    onChange={handleChange}
                    id="nivel_id"
                    values={values}
                    errors={errors}
                    touched={touched}
                    onBlur={handleBlur}
                    placeholder={"Buscar nombre del nivel"}
                    size="lg"
                    title="Nivel"
                    getter={getNiveles}
                    paramKey={"nombre"}
                    variant="gray-container"
                    arrElementsPath="elementos"
                    optionsFormatConfig={{
                      value: "id",
                      label: (el: NivelI) => `${el.nombre}`,
                    }}
                    defaultSelectedOptions={
                      defaultOptionsSelected.default_selected_nivel
                    }
                    required
                    // noOptionsMessage={`No hay opciones disponibles para el nombre ingresado`}
                    emptySelectMessage={`Ingresar un nombre`}
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
